export default __webpack_public_path__ + "static/media/emptyfile.9726262b.svg";